import { render } from "./UpdateAccountView.vue?vue&type=template&id=3e04f367&scoped=true"
import script from "./UpdateAccountView.vue?vue&type=script&lang=js"
export * from "./UpdateAccountView.vue?vue&type=script&lang=js"

import "./UpdateAccountView.vue?vue&type=style&index=0&id=3e04f367&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e04f367"]])

export default __exports__